import { LoginRequirementActionTypes } from '../actions/loginRequirementActions';
import { SsoLoginActionTypes } from '../actions/ssoLogin';
import LoginRecommend from '../constants/LoginRecommend';
import { RequestStates } from '../constants/RequestStates';
const initialState = {
  stagedEmail: '',
  stagedRememberLogin: false,
  loginRequirementRequestStatus: RequestStates.UNATTEMPTED,
  loginRequirement: {
    loginType: LoginRecommend.HUBSPOT,
    hardRequirement: false
  },
  hasSsoRequirement: false,
  useDark: false,
  loginRedirectUrl: undefined,
  allowFbSignup: false,
  hideSignupLink: false,
  signupParams: undefined,
  pageId: undefined,
  ssoError: undefined
};

const loginRequirementReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_BEGIN:
      return Object.assign({}, state, {
        loginRequirementRequestStatus: RequestStates.REQUESTING
      });

    case LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_SUCCESS:
      return Object.assign({}, state, {
        stagedEmail: action.payload.stagedEmail,
        stagedRememberLogin: action.payload.stagedRememberLogin,
        loginRequirement: action.payload.loginRequirement,
        hasSsoRequirement: action.payload.hasSsoRequirement,
        loginRequirementRequestStatus: RequestStates.SUCCEEDED,
        useDark: action.payload.useDark,
        loginRedirectUrl: action.payload.loginRedirectUrl,
        allowFbSignup: action.payload.allowFbSignup,
        hideSignupLink: action.payload.hideSignupLink,
        signupParams: action.payload.signupParams,
        pageId: action.payload.pageId
      });

    case LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_FAILURE:
      return Object.assign({}, state, {
        loginRequirement: {
          loginType: LoginRecommend.HUBSPOT,
          hardRequirement: false
        },
        hasSsoRequirement: false,
        loginRequirementRequestStatus: action.payload.isOnLoad ? RequestStates.FAILED_ON_LOAD : RequestStates.FAILED,
        useDark: false,
        loginRedirectUrl: undefined,
        allowFbSignup: false,
        hideSignupLink: false,
        signupParams: undefined,
        pageId: undefined
      });

    case SsoLoginActionTypes.SSO_LOGIN_FAILURE:
      {
        return Object.assign({}, state, {
          ssoError: action.error
        });
      }

    default:
      return state;
  }
};

export default loginRequirementReducer;